import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store';
import { removeFromCart, updateQuantity } from '../../store/slices/cartSlice';
import './Cart.css';

const Cart: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { items, total, subtotal } = useSelector((state: RootState) => state.cart);

  const trendingCategories = [
    { name: "Safety", image: "/assets/images/torch_light.png" },
    { name: "Machine", image: "/assets/images/sewing_machine.png" },
    { name: "Generator", image: "/assets/images/air_compressor.png" },
    { name: "Camera", image: "/assets/images/camera.png" },
    { name: "Cleaner", image: "/assets/images/vacuum_cleaner.png" },
    { name: "Stove", image: "/assets/images/induction_cooktop.png" }
  ];

  const handleRemove = (id: string) => {
    dispatch(removeFromCart(id));
  };

  const handleUpdateQty = (id: string, qty: number) => {
    if (qty > 0) {
      dispatch(updateQuantity({ itemId: id, quantity: qty }));
    }
  };

  return (
    <div className="cart-page-premium">
      <div className="cart-inner-container">
        
        {items.length === 0 ? (
          /* Main Empty Cart Card */
          <div className="empty-cart-banner-card">
            <div className="empty-cart-left-vector">
              <img src="/assets/images/order-confirmed 1.png" alt="Empty Cart Illustration" />
            </div>
            <div className="empty-cart-right-details">
              <h2>Your Cart is Currently empty</h2>
              <p>Add product and proceed</p>
              <button className="start-shopping-btn" onClick={() => navigate('/')}>
                Start Shopping
              </button>
            </div>
          </div>
        ) : (
          <div className="cart-content" style={{ display: 'flex', gap: '30px', marginTop: '20px' }}>
            <div className="cart-items" style={{ flex: '2', background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
              <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Your Cart ({items.length} items)</h2>
              {items.map(item => (
                <div key={item.id} className="cart-item" style={{ display: 'flex', gap: '20px', marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eee' }}>
                  <img src={item.product.image} alt={item.product.name} style={{ width: '100px', height: '100px', objectFit: 'contain' }} />
                  <div style={{ flex: '1' }}>
                    <h3 style={{ fontSize: '16px', marginBottom: '5px' }}>{item.product.name}</h3>
                    <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>{item.product.sku}</p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div className="qty-controls" style={{ display: 'flex', border: '1px solid #ddd', borderRadius: '4px' }}>
                        <button onClick={() => handleUpdateQty(item.id, item.quantity - 1)} style={{ padding: '5px 10px', background: '#f5f5f5', border: 'none', cursor: 'pointer' }}>-</button>
                        <span style={{ padding: '5px 15px', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd' }}>{item.quantity}</span>
                        <button onClick={() => handleUpdateQty(item.id, item.quantity + 1)} style={{ padding: '5px 10px', background: '#f5f5f5', border: 'none', cursor: 'pointer' }}>+</button>
                      </div>
                      <button onClick={() => handleRemove(item.id)} style={{ color: '#d11243', background: 'transparent', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Remove</button>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '18px' }}>
                    ₹{(item.product.discountedPrice || item.product.price) * item.quantity}
                  </div>
                </div>
              ))}
            </div>
            
            <div className="cart-summary" style={{ flex: '1', background: '#f9f9f9', padding: '20px', borderRadius: '8px', height: 'fit-content', position: 'sticky', top: '20px' }}>
              <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #ddd', paddingBottom: '10px' }}>Order Summary</h2>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <span>Subtotal</span>
                <span>₹{subtotal.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <span>Tax</span>
                <span>₹{(subtotal * 0.18).toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <span>Shipping</span>
                <span>{subtotal > 1000 ? 'Free' : '₹50.00'}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #ddd', fontWeight: 'bold', fontSize: '18px' }}>
                <span>Total</span>
                <span>₹{total.toFixed(2)}</span>
              </div>
              <button 
                onClick={() => navigate('/checkout')}
                style={{ width: '100%', padding: '15px', background: '#d11243', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: 'bold', marginTop: '20px', cursor: 'pointer' }}
              >
                PROCEED TO CHECKOUT
              </button>
            </div>
          </div>
        )}

        {/* Trending Categories */}
        <div className="trending-categories-section" style={{ marginTop: '50px' }}>
          <h3>Trending Categories</h3>
          <div className="trending-categories-grid">
            {trendingCategories.map((cat, idx) => (
              <div key={idx} className="trending-category-square-card">
                <div className="trending-img-box">
                  <img src={cat.image} alt={cat.name} />
                </div>
                <div className="trending-name-box">
                  <span>{cat.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Cart;
